import React from "react";
import classNames from "classnames";
import Modal from "react-responsive-modal";
import { DynamicModalProps } from "../../types/components";
import { trackEvent } from "../../services/eventTracker";
import "react-responsive-modal/styles.css";
import Cancel from "../../assets/images/icons/rebrand/cancel.svg";

const DynamicModal = ({ open, setClose, showCloseIcon = false, className, variant = "default", header, headerClassName, body, footer, onCloseEvent }: DynamicModalProps) => {

  const handleCloseClick = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();
    if (onCloseEvent) {
      trackEvent(onCloseEvent.name, onCloseEvent?.params);
    }
    setClose(false);
  }

  /**
   * Renders the close button on the modal
   */
  const renderCloseButton = (hide: boolean, onClose: () => void) => {
    if (!hide) {
      return (
        <button
          onClick={onClose}
          type="button"
          className="close btn btn-text btn-icon"
          data-dismiss="modal"
          aria-label="Close"
        >
          <img src={Cancel} alt="Close" />
        </button>
      );
    }
  };

  return (
    <Modal
      classNames={{
        modal: classNames("dynamic-modal", className, {
          "dynamic-modal--tight": variant === "tight",
        }),
      }}
      open={open}
      onClose={handleCloseClick}
      showCloseIcon={false}
      closeOnOverlayClick={true}
      center
    >
      <div className="modal-content">
        {header &&
          <div className={classNames("modal-header", headerClassName)}>
            {header}
            {renderCloseButton(!showCloseIcon, handleCloseClick)}
          </div>
        }

        <div className="modal-body">
          {body}
        </div>

        {footer &&
          <footer className="modal-footer">
            {footer}
          </footer>
        }
      </div>
    </Modal>
  );
}

export default DynamicModal;